import officeOnline from './OfficeOnline';

export const EDITORS = {
    office: officeOnline,
    R7: officeOnline,
    myoffice: officeOnline,
    myofficeAttaches: officeOnline,
};

export const EditorsIds = {
    myofficeAttaches: 'myofficeAttaches',
};

export const newDocNamesByExt = {
    docx: 'Новый документ',
    xlsx: 'Новая таблица',
    pptx: 'Новая презентация',
};

export const BUBBLE_ID = 'document-bubble';

export const X_IN_SHARED_FOLDER = 'x-in-shared-folder';

export const Editors = {
    MAILPAD: 'MailPad',
    OFFICE: 'office',
    R7: 'R7',
    MYOFFICE: 'myoffice',
    MYOFFICEATTACHES: 'myofficeAttaches',
} as const;
